import { FooterLink, type FooterLinkProps } from './FooterLink';

// Distributive Omit — preserves the FooterLinkProps discriminated union (regular `Omit`
// would intersect the variants' keys and drop the `asChild`/`href` discriminator).
type DistributiveOmit<T, K extends PropertyKey> = T extends unknown ? Omit<T, K> : never;

export type FooterSectionLinkProps = DistributiveOmit<FooterLinkProps, 'variant'>;

export function FooterSectionLink(props: FooterSectionLinkProps) {
  if (props.asChild) {
    return (
      <FooterLink asChild variant="section" className={props.className}>
        {props.children}
      </FooterLink>
    );
  }
  return (
    <FooterLink href={props.href} external={props.external} target={props.target} variant="section" className={props.className}>
      {props.children}
    </FooterLink>
  );
}
